import { render, staticRenderFns } from "./BaseHeaderBackButton.vue?vue&type=template&id=4a334b94&scoped=true"
import script from "./BaseHeaderBackButton.vue?vue&type=script&lang=ts"
export * from "./BaseHeaderBackButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseHeaderBackButton.vue?vue&type=style&index=0&id=4a334b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a334b94",
  null
  
)

export default component.exports